import log from 'loglevel';
import { isEmpty } from "../util/util";

const handleVersionChange = (option,
  currentHULADetails,
  dispatch,
  ) => {
  
  const { productVersionKeys, 
    crossGradeProducts,
    colName,
    selectedProduct,
    suggestedCrosGradeProduct,
  } = currentHULADetails;
  
  log.debug('User choose this version : ', option);
  const prodName = option.substring(0, option.length - 5);
  const releaseYear = option.slice(-4);

  let prodKey = '';
  if(!isEmpty(crossGradeProducts) && !isEmpty(colName)) {
    crossGradeProducts.forEach(product => {
      log.debug('currently serving -> ', product.productName, 'and year -> ', product.priorVersion);
      let { productName } = product;
      productName = productName.replace('Autodesk ', '');
      log.debug('cond 1 : ', productName === prodName);
      log.debug('cond 2 : ', product.priorVersion === releaseYear);
      if(productName === prodName && product.priorVersion === releaseYear) {
        prodKey = product.productKey
      }
    })
  }
  if(!isEmpty(productVersionKeys.productKey) && productVersionKeys.productKey[releaseYear]) {
    prodKey = productVersionKeys.productKey[releaseYear];
  }
  log.debug('product key : ', prodName,' yeah -> ', releaseYear,' and key -> ',prodKey);
  dispatch({
    type: 'ENTER_REQUESTING_VERSION',
    payload: {
      selectedProduct: prodName,
      selectedVersion : option,
      productKey: prodKey,
    },
  });

  const cond1 = !isEmpty(selectedProduct) && selectedProduct !== prodName
  const cond2 = !isEmpty(suggestedCrosGradeProduct) && suggestedCrosGradeProduct.includes(prodName); 
  if(cond1 || cond2) dispatch({ type: 'CROSS_GRADE_HULA_MESSAGE'})
}

export default handleVersionChange;